<template>
  <div class="outer-wrapper">
    <div class="editor-wrapper" v-show="!detailShow">
      <div class="title-wrapper">
        <span>材料</span>
      </div>
      <van-search placeholder="请输入搜索关键词" v-model="keyword" @search="onSearch" />
      <van-list
        v-model="itemTable.loading"
        :finished="itemTable.finished"
        finished-text="没有更多了"
        :error.sync="itemTable.error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <van-cell
          v-for="item in itemTable.tivdata"
          :key="item.id+'verify'"
          :title="item.grade"
          :label="'《'+item.standard+'》'"
          label-class="cell-label"
          @click="chooseItem(item)"
          is-link
          :value="item.ifValid"
          :value-class="calStat(item.ifValid)"
        ></van-cell>
      </van-list>
    </div>
    <div class="report-wrapper" v-show="detailShow">
      <van-nav-bar title="材料详情" left-text="返回" left-arrow @click-left="onClickBack" fixed></van-nav-bar>
      <p class="detail-title">{{currentItem.standard+'----'+currentItem.grade}}</p>
      <van-cell title="碳(C)" :value="elementRangeTextFac(currentItem.C0,currentItem.C1)" value-class="cell-value"/>
      <van-cell title="硅(Si)" :value="elementRangeTextFac(currentItem.Si0,currentItem.Si1)" value-class="cell-value"/>
      <van-cell title="锰(Mn)" :value="elementRangeTextFac(currentItem.Mn0,currentItem.Mn1)" value-class="cell-value"/>
      <van-cell title="磷(P)" :value="elementRangeTextFac(currentItem.P0,currentItem.P1)" value-class="cell-value"/>
      <van-cell title="硫(S)" :value="elementRangeTextFac(currentItem.S0,currentItem.S1)" value-class="cell-value"/>
      <van-cell title="铬(Cr)" :value="elementRangeTextFac(currentItem.Cr0,currentItem.Cr1)" value-class="cell-value"/>
      <van-cell title="镍(Ni)" :value="elementRangeTextFac(currentItem.Ni0,currentItem.Ni1)" value-class="cell-value"/>
      <van-cell title="铜(Cu)" :value="elementRangeTextFac(currentItem.Cu0,currentItem.Cu1)" value-class="cell-value"/>
      <van-cell title="钼(Mo)" :value="elementRangeTextFac(currentItem.Mo0,currentItem.Mo1)" value-class="cell-value"/>
      <van-panel title="其他：" desc status v-if="currentItem.other">
        <div class="d-wrapper">
            <table class="other-table">
                <tr v-for="x in JSON.parse(currentItem.other)" :key="x.element+'other'">
                    <td>{{x.element}}:</td>
                    <td>{{elementRangeTextFac(x.min,x.max)}}</td>
                </tr>
            </table>
        </div>
      </van-panel>
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));

function itemTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [
      /*
        grade
        standard

         */
    ]
  };
}

export default {
  name: "materialList",
  props: [],
  components: {},
  data() {
    return {
      itemTable: itemTableFac(),
      detailShow: false,
      currentItem: {},
      keyword: "",
    };
  },
  methods: {
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    onSearch() {
      this.itemTable = itemTableFac();
      this.onLoad();
    },
    calStat(stat) {
      if (stat === "现行") {
        return "c-green";
      } else if (stat === "已废止") {
        return "c-red";
      } else if (stat === "未实施") {
        return "c-blue";
      } else {
        return "c-no";
      }
    },
    onLoad() {
      this.itemTable.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.itemTable.Tpage,
          userToken: userToken,
          ask_data: "matList",
          selected_list: [],
          keyword: this.keyword
        })
        .then(response => {
          for (let ele of response.data.res_record) {
            this.itemTable.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.itemTable.Tpage.currentSize
          ) {
            this.itemTable.finished = true;
          }
          this.itemTable.loading = false;
          this.itemTable.Tpage.currentPage++;
        });
    },
    chooseItem(val) {
      this.currentItem = val;
      this.detailShow = true;
    },
    onClickBack() {
      this.detailShow = false;
    },
    elementRangeTextFac(min, max) {
      if (min === null && max === null) {
        return "-";
      }
      min = parseFloat(min);
      max = parseFloat(max);
      if (min === 0 && max === 100) {
        return "-";
      } else if (min === 0 && max !== 100) {
        return "≤" + max;
      } else if (min !== 0 && max === 100) {
        return "≥" + min;
      } else {
        return min + "~" + max;
      }
    }
  }
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-left: 0.6rem;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: left;
  text-indent: 1rem;
  font-size: 0.6rem;
}

.cell-label {
  width: 180%;
  color: #666;
}
.detail-title {
  text-align: center;
  font-size: 0.8rem;
  padding: 0.5rem 0;
}
.c-green {
  color: rgb(33, 99, 33);
}

.c-red {
  color: rgb(173, 28, 28);
}

.c-blue {
  color: rgb(20, 59, 92);
}

.c-no {
  color: #999;
}
.other-table{
    width:100%;
}
.other-table td{
    height:1rem;
}
.other-table td:last-child{
    text-align: right;
    font-weight:600;
    color:#333;
    font-size:0.65rem;
}
.cell-value{
    font-weight: 600;
    color:#333;
}
</style>